var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Ig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H100V100H0V0ZM21.7391 36.9565H13.0435V81.2551L21.7391 89.1304V36.9565ZM58.4541 69.0013H72.7856C71.9984 70.9395 70.8857 72.7489 69.479 74.3431C66.4616 77.7644 62.2994 79.9659 57.7735 80.536C53.2477 81.106 48.6696 80.0043 44.8985 77.4371C41.1275 74.8709 38.423 71.0162 37.2924 66.5973C36.162 62.1775 36.6834 57.4981 38.7588 53.4361C40.8343 49.374 44.3211 46.2092 48.5645 44.5354C52.808 42.8626 57.5163 42.7948 61.8057 44.3467C66.0952 45.8986 69.6707 48.9631 71.8611 52.9643L79.2708 48.9081C76.0924 43.1015 70.904 38.6551 64.6796 36.4034C58.4552 34.1517 51.6229 34.249 45.4653 36.6776C39.3076 39.1062 34.2482 43.698 31.2365 49.5931C28.2248 55.4872 27.4682 62.2777 29.1086 68.6908C30.749 75.1028 34.6736 80.6962 40.1456 84.4212C45.6178 88.1452 52.2611 89.7442 58.8286 88.9177C65.3959 88.0901 71.4357 84.8949 75.8142 79.9315C79.9379 75.2562 82.3208 69.3149 82.5842 63.1092L82.6087 62.9627V60.9499H66.1836L58.4541 69.0013Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Ig);
export default __webpack_public_path__ + "static/media/3_IG.7157965d6860c37960469268e44ec3f6.svg";
export { ForwardRef as ReactComponent };